export default __webpack_public_path__ + "static/media/lock-golden.aabc0ca0.svg";